import React from 'react';
export default function StatCard({ label, value, icon: Icon, color = '#0d6efd', sub }) {
  return (
    <div className="stat-card" style={{ background: `linear-gradient(135deg, ${color}, ${color}cc)` }}>
      {Icon && <Icon className="stat-icon" />}
      <div className="stat-num">{value ?? '—'}</div>
      <div className="stat-label">{label}</div>
      {sub && <div style={{ fontSize: '0.75rem', opacity: 0.75, marginTop: 4 }}>{sub}</div>}
    </div>
  );
}
